export const COMPETENCE_QUESTIONS_PATH = 'question/competences/test'
export const COMPETENCE_QUESTION_SAVE_PATH = 'competence_result/save/question'
export const COMPETENCE_FINISH_PATH = 'competence_result/finish/test'
export const COMPETENCE_CURRENT_RESULTS = 'competence_result/current_results'
